import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'redo-icon',
  templateUrl: './redo-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RedoIconComponent {}
